'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_components_NotificationIndicator(showIndicator, indicator, contents, evidence$1) {
  this.Lapp_components_NotificationIndicator__f_showIndicator = null;
  this.Lapp_components_NotificationIndicator__f_indicator = null;
  this.Lapp_components_NotificationIndicator__f_contents = null;
  this.Lapp_components_NotificationIndicator__f_evidence$1 = null;
  this.Lapp_components_NotificationIndicator__f_showIndicator = showIndicator;
  this.Lapp_components_NotificationIndicator__f_indicator = indicator;
  this.Lapp_components_NotificationIndicator__f_contents = contents;
  this.Lapp_components_NotificationIndicator__f_evidence$1 = evidence$1;
}
export { $c_Lapp_components_NotificationIndicator as $c_Lapp_components_NotificationIndicator };
$c_Lapp_components_NotificationIndicator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_components_NotificationIndicator.prototype.constructor = $c_Lapp_components_NotificationIndicator;
/** @constructor */
function $h_Lapp_components_NotificationIndicator() {
}
export { $h_Lapp_components_NotificationIndicator as $h_Lapp_components_NotificationIndicator };
$h_Lapp_components_NotificationIndicator.prototype = $c_Lapp_components_NotificationIndicator.prototype;
$c_Lapp_components_NotificationIndicator.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_components_NotificationIndicator.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-40083914), true);
});
$c_Lapp_components_NotificationIndicator.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_components_NotificationIndicator)) {
    var x = this.Lapp_components_NotificationIndicator__f_showIndicator;
    var x$2 = x$0.Lapp_components_NotificationIndicator__f_showIndicator;
    if ((x === x$2)) {
      var x$3 = this.Lapp_components_NotificationIndicator__f_indicator;
      var x$4 = x$0.Lapp_components_NotificationIndicator__f_indicator;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lapp_components_NotificationIndicator__f_contents;
      var x$6 = x$0.Lapp_components_NotificationIndicator__f_contents;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_components_NotificationIndicator.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_components_NotificationIndicator.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_components_NotificationIndicator.prototype.productPrefix__T = (function() {
  return "NotificationIndicator";
});
$c_Lapp_components_NotificationIndicator.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_components_NotificationIndicator__f_showIndicator;
      break;
    }
    case 1: {
      return this.Lapp_components_NotificationIndicator__f_indicator;
      break;
    }
    case 2: {
      return this.Lapp_components_NotificationIndicator__f_contents;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_components_NotificationIndicator.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "showIndicator";
      break;
    }
    case 1: {
      return "indicator";
      break;
    }
    case 2: {
      return "contents";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_components_NotificationIndicator.prototype.render__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag().apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("indicator"), ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).$less$minus$minus__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_inserters_DynamicInserter($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_SignalOfBooleanExts$package$().splitBooleanAsOption__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal(this.Lapp_components_NotificationIndicator__f_showIndicator, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$14) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
    var component = this.Lapp_components_NotificationIndicator__f_indicator.apply__O();
    var r = this.Lapp_components_NotificationIndicator__f_evidence$1;
    return r.asNode__O__Lcom_raquo_laminar_nodes_ChildNode(component);
  })))), this.Lapp_components_NotificationIndicator__f_contents])));
});
$c_Lapp_components_NotificationIndicator.prototype.render__Lcom_raquo_laminar_nodes_ChildNode = (function() {
  return this.render__Lcom_raquo_laminar_nodes_ReactiveHtmlElement();
});
function $isArrayOf_Lapp_components_NotificationIndicator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_components_NotificationIndicator)));
}
export { $isArrayOf_Lapp_components_NotificationIndicator as $isArrayOf_Lapp_components_NotificationIndicator };
var $d_Lapp_components_NotificationIndicator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_components_NotificationIndicator, "app.components.NotificationIndicator", ({
  Lapp_components_NotificationIndicator: 1,
  Lframework_utils_IsRenderableNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_components_NotificationIndicator as $d_Lapp_components_NotificationIndicator };
//# sourceMappingURL=app.components.-Notification-Indicator.js.map
